import React from "react";
import { connect } from "react-redux";
import { NumberInput, Input } from "@revvsales/components";
import { RevvForm, CustomSelect } from "../../../../commonComponents";
import { CURRENCY_SYMBOL } from "../../../../constants/common";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";
import { CurrencyOptions } from "../../../../constants/customDynamicMeta";
// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class AmountField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      amountFieldValues: this._getDataForPrepopulate(props),
    };
  }

  componentDidMount() {
    this.props.setFlagForDefault(true);
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (propsData.meta && propsData.meta.default) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.AMOUNT),
    );
    if (propsData.meta && propsData.meta.currency !== "") {
      returnData = {
        currency: this._prepareOptionsForAmount(propsData.meta.currency),
        default: propsData.meta.default,
      };
    }
    return returnData;
  };

  _prepareOptionsForAmount = data => {
    let returnData = "";
    if (data) {
      returnData = { name: data, id: data, currency: data };
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
  };

  render() {
    const { showDefaultValue, amountFieldValues } = this.state;
    return (
      <React.Fragment>
        <RevvForm
          initialFormValue={amountFieldValues}
          customFieldName="AMOUNT"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const {
              handleChangeByName,
              // handleBlur,
              values,
            } = formProps;

            if (!showDefaultValue && values.default !== "") {
              values.default = "";
            }
            const data = {
              currency:
                values.currency.currency !== undefined
                  ? values.currency.currency
                  : "",
              default: values.default,
            };

            if (
              data.currency !== "" &&
              !showDefaultValue &&
              data.default === ""
            ) {
              this.props.setFlagForDefault(false);
            } else if (
              data.currency !== "" &&
              showDefaultValue &&
              data.default === ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(false);
            } else if (
              data.currency !== "" ||
              (showDefaultValue && data.default !== "")
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(true);
            }
            this.props.setMetaFieldValues(data);
            return (
              <React.Fragment>
                <span
                  className="revvform-label"
                  data-test="amountfield-revvform-label">
                  Currency
                  <span
                    className="requiredwitherr-input"
                    data-test="amountfield-requiredwitherr-input">
                    *
                  </span>
                </span>
                <CustomSelect
                  id="currency"
                  data-test="amountfield-currency-input"
                  name="currency"
                  value={values.currency}
                  getOptionLabel={({ name }) => name}
                  options={CurrencyOptions}
                  _handleChangeInSelect={value =>
                    handleChangeByName(value, "currency")
                  }
                  required
                />
                {values.currency.name && (
                  <React.Fragment>
                    <div
                      className="dynamicfieldcustom-default-container"
                      data-test="amountfield-dynamicfieldcustom-default-container">
                      <Input
                        id="checkbox"
                        data-test="amountfield-defaultvalue-checkboxinput"
                        type="checkbox"
                        checked={showDefaultValue}
                        onChange={() => this._toggleDefaultValue()}
                        className="dynamicfieldcustom-footer-input errorborder"
                      />
                      <span
                        className="dynamicfieldcustom-footer-checkboxinput"
                        data-test="amountfield-dynamicfieldcustom-footer-checkboxinput">
                        This has a default value
                      </span>
                    </div>
                  </React.Fragment>
                )}

                {showDefaultValue && values.currency.name && (
                  <div>
                    <span
                      className="revvform-label"
                      data-test="amountfield-revvform-label-defaultvalue">
                      Default value
                      <span
                        className="requiredwitherr-input"
                        data-test="amountfield-defaultvalue-requiredwitherr-input">
                        {" "}
                        *
                      </span>
                    </span>
                    <NumberInput
                      autoFocus
                      id="default"
                      data-test="amountfield-defaultvaluefield-inputbox"
                      name="default"
                      type="number"
                      value={values && values.default}
                      isFloat
                      isCurrency={values.currency.currency !== "PRICEBOOK"}
                      inpCurrencySymbol={
                        CURRENCY_SYMBOL[values.currency.currency]
                      }
                      placeholder="Enter field default value"
                      className=""
                      onChange={value => handleChangeByName(value, "default")}
                      required
                    />
                  </div>
                )}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AmountField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/AmountField.js